import Console from './Console';
import Binding from './Binding';
import Bindings from './Bindings';
import ModelBindingsForName from './ModelBindingsForName';
const  console = Console;
export default function BindingsHandler(model){
	const self = this;
	const mapNameToModelBindings = {};
	model.bind = (name, callbackSet)=>{
		var view = this;
		var viewBindings = getViewBindings(view);
		var bindings = mapNameToModelBindings[name];
		if(!bindings){
			const binding = new Binding(name, callbackSet);
			viewBindings.add(binding);
			const modelBindings = new ModelBindingsForName(name, binding);
			modelBindings.addEventListener('dispose', callbackDisposeModelBindings);
			mapNameToModelBindings[name]=modelBindings;
			return viewBindings;
		}
		if(bindings.containsCallbackSet(callbackSet))return false;
		const binding = new Binding(name, callbackSet);
		viewBindings.add(binding);
		bindings.add(binding);
		return viewBindings;
	};
	model.unbind = (name, callbackSet)=>{
		var bindings = mapNameToModelBindings[name];
		if(!bindings)return;
		var binding = bindings.getByCallbackSet(callbackSet);
		if(!binding)return;
		binding.dispose();
	};
	this.changed = function(name, value){
		var bindings =  mapNameToModelBindings[name];
		if(!bindings)return;
		bindings.changed(value);
	};
	this.dispose= function(){
		for(var i in mapNameToModelBindings){
			var modelBindings = mapNameToModelBindings[i];
			modelBindings.dispose();
		}
		mapNameToModelBindings={};
	};
	function getViewBindings(view){
		if(!view.bindings){
			view.bindings = new Bindings();
		}
		return view.bindings;
	}
	function callbackDisposeModelBindings(e){
		var name = e.bindings.getName();
		if(mapNameToModelBindings[name])
			delete mapNameToModelBindings[name];
	}
}